import { Outlet } from "react-router-dom";

export default function RootLayout() {
  return (
    <div
      className="custom-scrollbar"
      style={{ height: "100vh", overflow: "auto" }}
      id="root-layout"
    >
      <Outlet />
    </div>
  );
}
